"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "DuplicateService", {
    enumerable: true,
    get: function() {
        return DuplicateService;
    }
});
const _common = require("@nestjs/common");
const _nocodbsdk = require("nocodb-sdk");
const _models = require("~/models");
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
const _cli = require("~/cli");
const _exportImportHelpers = require("~/helpers/exportImportHelpers");
const _Jobs = require("~/interface/Jobs");
const _apphooksservice = require("~/services/app-hooks/app-hooks.service");
const _basesservice = require("~/services/bases.service");
const _jobsserviceinterface = require("~/modules/jobs/jobs-service.interface");
const _ncError = require("~/helpers/ncError");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
function _ts_param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
let DuplicateService = class DuplicateService {
    async duplicateBase({ context, req, baseId, sourceId, body }) {
        var _ref, _ref1;
        var _body_base, _body_base1, _body_base2, _body_base3, _body_base4, _body_base5;
        const base = await _models.Base.get(context, baseId);
        if (!base) {
            _ncError.NcError.get(context).baseNotFound(baseId);
        }
        const source = sourceId ? await _models.Source.get(context, sourceId) : (await base.getSources())[0];
        if (!source) {
            if (sourceId) {
                _ncError.NcError.get(context).sourceNotFound(sourceId);
            }
            _ncError.NcError.get(context).noSourcesFound();
        }
        if (((_body_base = body.base) == null ? void 0 : _body_base.fk_workspace_id) && ((_body_base1 = body.base) == null ? void 0 : _body_base1.fk_workspace_id) !== '' && (base.fk_workspace_id || ((_body_base2 = body.base) == null ? void 0 : _body_base2.fk_workspace_id)) && base.fk_workspace_id !== ((_body_base3 = body.base) == null ? void 0 : _body_base3.fk_workspace_id)) {
            await this.handleDifferentWs({
                context,
                req,
                sourceBase: base,
                targetBase: body.base
            });
        }
        const targetWorkspaceId = (_ref = (_body_base4 = body.base) == null ? void 0 : _body_base4.fk_workspace_id) != null ? _ref : context.workspace_id;
        const bases = await _models.Base.list(targetWorkspaceId);
        const targetBaseTitle = (_ref1 = (_body_base5 = body.base) == null ? void 0 : _body_base5.title) != null ? _ref1 : base.title;
        const uniqueTitle = (0, _exportImportHelpers.generateUniqueName)(`${targetBaseTitle} copy`, bases.map((p)=>p.title));
        const parentAuditId = await _Noco.default.ncAudit.genNanoid(_cli.MetaTable.AUDIT);
        req.ncParentAuditId = parentAuditId;
        const dupProject = await this.basesService.baseCreate({
            base: _extends({
                title: uniqueTitle,
                status: _nocodbsdk.ProjectStatus.JOB
            }, body.base || {}),
            user: {
                id: req.user.id,
                email: req.user.email,
                display_name: req.user.display_name
            },
            req
        });
        this.appHooksService.emit(_nocodbsdk.AppEvents.BASE_DUPLICATE_START, {
            sourceBase: base,
            destBase: dupProject,
            user: req.user,
            req,
            context,
            id: parentAuditId,
            options: body == null ? void 0 : body.options
        });
        req.ncParentAuditId = parentAuditId;
        const job = await this.jobsService.add(_Jobs.JobTypes.DuplicateBase, {
            context,
            user: req.user,
            baseId: base.id,
            sourceId: source.id,
            dupProjectId: dupProject.id,
            dupWorkspaceId: dupProject.fk_workspace_id,
            options: body.options || {},
            req
        });
        return {
            id: job.id,
            base_id: dupProject.id
        };
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async handleDifferentWs(params) {
        _ncError.NcError.notImplemented();
    }
    constructor(jobsService, basesService, appHooksService){
        this.jobsService = jobsService;
        this.basesService = basesService;
        this.appHooksService = appHooksService;
    }
};
DuplicateService = _ts_decorate([
    (0, _common.Injectable)(),
    _ts_param(0, (0, _common.Inject)('JobsService')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _jobsserviceinterface.IJobsService === "undefined" ? Object : _jobsserviceinterface.IJobsService,
        typeof _basesservice.BasesService === "undefined" ? Object : _basesservice.BasesService,
        typeof _apphooksservice.AppHooksService === "undefined" ? Object : _apphooksservice.AppHooksService
    ])
], DuplicateService);
